import { connect } from "react-redux";

import AnswerAttribute from "components/answer/AnswerAttribute";

import {
  //  set,
  setNextSurveyAttr,
  setPrevSurveyAttr
} from "redux/modules/answer/answerAttribute";
import { setAttrResult } from "redux/modules/answer/answerResult";
import { startEffect, finishEffect } from "redux/modules/answer/answerHeader";
import { openErrorDialog } from "redux/modules/errorDialog";

import history from "utils/history";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader,
  answerAttribute: state.answerAttribute,
  isEffecting: state.answerHeader.isEffecting,
  answerStart: state.answerStart,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("invalidOperation")));
  },
  selectItem: (currentSurveyAttr, attrItem, surveyAttrCount) => {
    dispatch(setAttrResult(currentSurveyAttr, attrItem));
    dispatch(startEffect());

    // ボタンのエフェクトを待つ
    setTimeout(() => {
      if (currentSurveyAttr.order < surveyAttrCount) {
        // 次の属性をセット
        dispatch(setNextSurveyAttr());
      } else {
        history.push("/question_ready", ownProps);
      }

      dispatch(finishEffect());
    }, 300);
  },
  handlePrevBtn: order => {
    dispatch(startEffect());

    setTimeout(() => {
      if (order > 1) {
        dispatch(setPrevSurveyAttr());
      } else {
        ownProps.history.goBack();
      }

      dispatch(finishEffect());
    }, 300);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerAttribute);



// WEBPACK FOOTER //
// ./src/containers/preview/AnswerAttributeContainer.js